import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 12, fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { fill: "#d00c33", d: "m0,6h18v6H0zm3,0a4,4 0 0,0 8,0a4,4 0 0,0-8,0" }));
const ForwardRef = forwardRef(SvgGl);
const Memo = memo(ForwardRef);
export default Memo;
